import { prepareBaseListApiParams } from '@/api/helpers/apiHelpers';
import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { OrganizationEditType } from '../types/types';
import {
  CreateOrganizationPayloadType,
  createOrganizationApi,
} from '@/api/v1/opco/organizations/createOrganizationApi';
import { getOrganizationsApi } from '@/api/v1/opco/organizations/getOrganizationsApi';
import { getOrganizationApi } from '@/api/v1/opco/organizations/getOrganizationApi';
import { updateOrganizationApi } from '@/api/v1/opco/organizations/updateOrganizationApi';
import {
  CreateOrganizationWithExistingUserPayloadType,
  createOrganizationWithExistingUserApi,
} from '@/api/v1/opco/users/createOrganizationWithExistingUserApi';
import { getAuthConfirmationTokenHeader } from '@/helpers/apiHelpers/requestHelpers';
import { QueryParamsType } from '@/api/helpers/apiParamsHelpers';

export const loadOrganizations = async (params: QueryParamsType) => {
  const apiParams = prepareBaseListApiParams(params);

  try {
    const response = await getOrganizationsApi(apiParams);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const loadOrganization = async (id: string) => {
  try {
    const response = await getOrganizationApi(id);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const createOrganization = async (payload: CreateOrganizationPayloadType, pinToken: string) => {
  const options = getAuthConfirmationTokenHeader(pinToken);

  try {
    const response = await createOrganizationApi(payload, options);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const createOrganizationWithExistingUser = async (
  payload: CreateOrganizationWithExistingUserPayloadType,
  pinToken: string
) => {
  const options = getAuthConfirmationTokenHeader(pinToken);

  try {
    const response = await createOrganizationWithExistingUserApi(payload, options);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};

export const updateOrganization = async (id: string, payload: OrganizationEditType) => {
  try {
    const response = await updateOrganizationApi(id, payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
